import React from 'react'
import PropTypes from 'prop-types'
import { Steps } from 'antd'

import 'styles/AntOverrides.css'
import 'styles/ChecComponents.css'

const ChecSteps = ({
  currentStep,
  steps,
  direction,
  labelPlacement,
  size,
  status,
}) => (
  <Steps
    current={currentStep}
    direction={direction}
    labelPlacement={labelPlacement}
    size={size}
    status={status}
  >
    {steps.map(({ key, title, description, status, icon, onClick }) => (
      <Steps.Step
        key={`${key}${status}${icon}`}
        title={title}
        description={description}
        status={status}
        onClick={onClick}
        icon={icon}
      />
    ))}
  </Steps>
)

ChecSteps.defaultProps = {
  currentStep: 0,
  direction: 'horizontal',
  labelPlacement: 'horizontal',
  size: 'default',
  status: 'process',
}

ChecSteps.propTypes = {
  currentStep: PropTypes.number,
  // TODO: Define shape of step objects
  steps: PropTypes.arrayOf(PropTypes.object),
  direction: PropTypes.oneOf(['horizontal', 'vertical']),
  labelPlacement: PropTypes.oneOf(['horizontal', 'vertical']),
  size: PropTypes.oneOf(['default', 'small']),
  status: PropTypes.oneOf(['wait', 'process', 'finish', 'error']),
}

export default ChecSteps
